import Base from '../Pages/Base'
import ListCategoriasPlanejamentoSaude from '../Pages/Categorias/List'
import FormCategoriasPlanejamentoSaude from '../Pages/Categorias/Form'
import ListPlanejamentoSaude from '../Pages/Detalhes/List'
import FormPlanejamentoSaude from '../Pages/Detalhes/Form'

export default [
	{
		path: 'links/planejamento-saude',
		component: Base,
		children: [
			{
				path: '',
				name: 'ListCategoriasPlanejamentoSaude',
				component: ListCategoriasPlanejamentoSaude,
				meta: {
					path: '/links/planejamento-saude',
					pai: 'Links',
					title: 'Admin - Planejamento Saúde',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Planejamento Saúde',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			
			{
				path: 'novo',
				name: 'FormCategoriasPlanejamentoSaude',
				component: FormCategoriasPlanejamentoSaude,
				meta: {
					path: '/links/planejamento-saude',
					pai: 'Links',
					title: 'Admin - Planejamento Saúde - Novo',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Planejamento Saúde',
						class: '',
						active: false,
						url: '/links/planejamento-saude'
					},
					{
						pagina: 'Novo',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			
			{
				path: 'editar/:id',
				name: 'FormCategoriasPlanejamentoSaudeEditar',
				component: FormCategoriasPlanejamentoSaude,
				meta: {
					path: '/links/planejamento-saude',
					pai: 'Links',
					title: 'Admin - Planejamento Saúde - Editar',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Planejamento Saúde',
						class: '',
						active: false,
						url: '/links/planejamento-saude'
					},
					{
						pagina: 'Editar',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			
			{
				path: ':id',
				name: 'ListPlanejamentoSaude',
				component: ListPlanejamentoSaude,
				meta: {
					path: '/links/planejamento-saude',
					pai: 'Links',
					title: 'Admin - Planejamento Saúde - Editar',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Planejamento Saúde',
						class: '',
						active: false,
						url: '/links/planejamento-saude'
					},
					{
						pagina: 'Carregando...',
						class: '',
						active: true,
						url: false,
						newClass: 'menu-selecionado'
					}],
					noCache: true
				},
			},

			{
				path: ':id/novo',
				name: 'FormPlanejamentoSaude',
				component: FormPlanejamentoSaude,
				meta: {
					path: '/links/planejamento-saude',
					pai: 'Links',
					title: 'Admin - Planejamento Saúde - Novo',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Planejamento Saúde',
						class: '',
						active: false,
						url: '/links/planejamento-saude'
					},
					{
						pagina: 'Carregando...',
						class: '',
						active: false,
						url: '/',
						ref: 'menuSelecionado'
					},
					{
						pagina: 'Novo',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},

			{
				path: ':id/editar/:cat',
				name: 'FormPlanejamentoSaudeEditar',
				component: FormPlanejamentoSaude,
				meta: {
					path: '/links/planejamento-saude',
					pai: 'Links',
					title: 'Admin - Planejamento Saúde - Editar',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Planejamento Saúde',
						class: '',
						active: false,
						url: '/links/planejamento-saude'
					},
					{
						pagina: 'Carregando...',
						class: '',
						active: false,
						url: '/',
						ref: 'menuSelecionado'
					},
					{
						pagina: 'Editar',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
		]
	}
]